import React from "react";
import {
  Box,
  Flex,
  VStack,
  Text,
  IconButton,
  Button,
  Image,
  useBreakpointValue,
} from "@chakra-ui/react";
import { CloseIcon } from "@chakra-ui/icons";
import arrow from "./Images/Button-Arrow.svg";

export function OfferPopup({ onClose }) {
  const phone = "601170180057";
  const textMsg = "Hi there! I’d like to learn more about your services.";
  const whatsappHref = `https://api.whatsapp.com/send?phone=${phone}&text=${encodeURIComponent(
    textMsg
  )}`;

  // Responsive sizing
  const popupW = useBreakpointValue({ base: "100%", md: "800px" });
  const popupP = useBreakpointValue({ base: "16px", md: "40px" });
  const titleSize = useBreakpointValue({ base: "18px", md: "24px" });
  const cardW = useBreakpointValue({ base: "100%", md: "480px" });
  const pillSize = useBreakpointValue({ base: "20px", md: "20px" });
  const cardTitleSize = useBreakpointValue({ base: "14px", md: "20px" });
  const cardDescSize = useBreakpointValue({ base: "12px", md: "16px" });

  // Offer definitions
  const offers = [
    {
      title: "Full Cambridge IGCSE ICT Course",
      desc: "for every 2 subjects sign ups",
    },
    {
      title: "Full Cambridge IGCSE Subject of Choice",
      desc: "for every 3 subjects sign ups",
    },
  ];

  return (
    <Box
      position="fixed"
      inset="0"
      bg="rgba(0,0,0,0.4)"
      display="flex"
      alignItems="center"
      justifyContent="center"
      zIndex="10000"
      p={popupP}
    >
      <Box
        bg="white"
        w={popupW}
        borderRadius="20px"
        p={popupP}
        maxH="90vh"
        overflowY="auto"
        position="relative"
      >
        <IconButton
          aria-label="Close"
          icon={<CloseIcon boxSize="16px" color="#232424" />}
          onClick={onClose}
          position="absolute"
          top={popupP}
          right={popupP}
          w="44px"
          h="39px"
          p="6px"
          borderRadius="57px"
          bg="#F3F3F3"
        />

        <Text
          color="#062A44"
          fontSize={titleSize}
          fontWeight="500"
          lineHeight="1.2"
          w={{ base: "90%", md: "600px" }}
        >
          Limited Time <Text as="span" color="#0069CA">OFFER!!</Text> for our Complete IGCSE Subjects Programs
        </Text>

        <VStack spacing="20px" align="flex-start" mt="24px">
          {offers.map((offer, idx) => (
            <Flex
              key={idx}
              w={cardW}
              p="14px 10px"
              align="flex-start"
              gap="16px"
              borderRadius="34px"
              bg="#EBF2F7"
            >
              <Flex
                p="8px"
                justify="center"
                align="center"
                borderRadius="24px"
                bg="#0069CA"
              >
                <Text color="#EBF2F7" fontSize={pillSize} fontWeight="600">
                  Free
                </Text>
              </Flex>
              <VStack align="flex-start" spacing="4px">
                <Text
                  color="#000"
                  fontSize={cardTitleSize}
                  fontWeight="500"
                  lineHeight="1.2"
                >
                  {offer.title}
                </Text>
                <Text
                  color="#000"
                  fontSize={cardDescSize}
                  fontStyle="italic"
                  fontWeight="300"
                  lineHeight="1.2"
                >
                  {offer.desc}
                </Text>
              </VStack>
            </Flex>
          ))}

          <Flex w="100%" justify="flex-end" pt="16px">
            <Button
              as="a"
              href={whatsappHref}
              target="_blank"
              rel="noopener noreferrer"
              borderRadius="24px"
              border="2.5px solid #E8E8E8"
              px={6}
              py={3}
              variant="outline"
            >
              <Flex align="center" gap="8px">
                <Text fontSize="14px" fontWeight="400">
                  Get Started For Free
                </Text>
                <Image src={arrow} alt="arrow" boxSize="20px" />
              </Flex>
            </Button>
          </Flex>
        </VStack>
      </Box>
    </Box>
  );
}
